(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scc-filter-bar"] && !Shopify.designMode) return;
  try {
    
  /**
   * Shop filters.
   *
   * Within a group the checked values are OR'd (Instagram OR Branding); across
   * groups they are AND'd (Beginner AND Instagram). That is what people expect
   * from faceted filtering and is exactly what native tag URLs cannot express.
   *
   * The controls are relocated into Horizon's own facets toolbar so they line up
   * with Price and Sort instead of sitting in a separate band above them.
   */
  (() => {
    const facets = document.querySelector('[data-scc-facets]');
    const mapEl = document.querySelector('[data-scc-tagmap]');
    if (!facets || !mapEl) return;

    let tagMap = {};
    try {
      tagMap = JSON.parse(mapEl.textContent);
    } catch (e) {
      return;
    }

    // Sit beside the native Price control. `.facets__filters-wrapper` is the
    // flex row Price itself lives in, so appending there puts all three
    // controls on one line. Falls back to leaving the markup where it was
    // rendered if Horizon ever changes that class.
    const host = document.querySelector('.facets__filters-wrapper');
    if (host) host.appendChild(facets);

    // The control bar belongs above the grid, level with Sort.
    const bar = document.querySelector('[data-scc-filterbar]');
    const sortHost = document.querySelector('.facets-controls-wrapper, .facets__controls, .facets');
    if (bar && sortHost) sortHost.insertBefore(bar, sortHost.firstChild);

    // Direct children only. Matching inner card wrappers and then moving them
    // promotes them to grid items and blows up the column layout.
    const cardSelector = '.product-grid > li';

    const handleOf = (card) => {
      const a = card.querySelector('a[href*="/products/"]');
      if (!a) return null;
      const m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      return m ? m[1] : null;
    };

    const range = facets.querySelector('[data-scc-range]');
    const rMin = range && range.querySelector('[data-scc-min]');
    const rMax = range && range.querySelector('[data-scc-max]');
    const priceMax = Number(facets.dataset.priceMax || 0);
    const priceMin = Number(facets.dataset.priceMin || 0);

    // Snap back on release if anything ever lands below the cheapest product.
    const snapUp = () => {
      if (rMin && Number(rMin.value) < priceMin) rMin.value = String(priceMin);
      if (rMax && Number(rMax.value) < priceMin) rMax.value = String(priceMin);
    };

    // Cache each card's price once, read from the rendered money string.
    const priceOf = (card) => {
      if (card.dataset.sccPrice) return Number(card.dataset.sccPrice);
      const el = card.querySelector('.price, [class*="price"]');
      const m = el && el.textContent.match(/([\d,]+(?:\.\d+)?)/);
      const v = m ? Number(m[1].replace(/,/g, '')) : 0;
      card.dataset.sccPrice = String(v);
      return v;
    };

    const apply = () => {
      const groups = {};
      facets.querySelectorAll('[data-scc-facet]').forEach((f) => {
        const on = [...f.querySelectorAll('[data-scc-check]:checked')].map((c) => c.value);
        if (on.length) groups[f.dataset.sccFacet] = on;
        const badge = f.querySelector('[data-scc-count]');
        if (badge) {
          badge.textContent = on.length ? String(on.length) : '';
          badge.hidden = on.length === 0;
        }
        f.classList.toggle('scc-facet--on', on.length > 0);
      });

      const active = Object.values(groups);
      const cards = document.querySelectorAll(cardSelector);
      let shown = 0;

      let lo = 0;
      let hi = priceMax;
      if (rMin && rMax) {
        lo = Math.max(priceMin, Math.min(Number(rMin.value), Number(rMax.value)));
        hi = Math.max(Number(rMin.value), Number(rMax.value));
        const fill = facets.querySelector('[data-scc-fill]');
        const span = priceMax - priceMin;
        if (fill && span > 0) {
          fill.style.left = ((lo - priceMin) / span) * 100 + '%';
          fill.style.right = 100 - ((hi - priceMin) / span) * 100 + '%';
        }
        const oMin = facets.querySelector('[data-scc-out-min]');
        const oMax = facets.querySelector('[data-scc-out-max]');
        if (oMin) oMin.textContent = '$' + lo;
        if (oMax) oMax.textContent = '$' + hi;
        const priceFacet = facets.querySelector('[data-scc-facet="price"]');
        if (priceFacet) {
          const narrowed = lo > priceMin || hi < priceMax;
          const badge = priceFacet.querySelector('[data-scc-count]');
          if (badge) {
            badge.textContent = narrowed ? '1' : '';
            badge.hidden = !narrowed;
          }
          if (narrowed) active.push(['__price__']);
        }
      }

      cards.forEach((card) => {
        const handle = handleOf(card);
        const tags = handle && tagMap[handle] ? tagMap[handle] : [];
        const price = priceOf(card);
        const inPrice = price >= lo && price <= hi;
        // every active tag group must have at least one of its values on the
        // product, and the price must sit inside the range
        const ok =
          inPrice &&
          active
            .filter((values) => values[0] !== '__price__')
            .every((values) => values.some((v) => tags.includes(v)));
        card.hidden = !ok;
        card.style.display = ok ? '' : 'none';
        if (ok) shown++;
      });

      // Product order now comes from the manual "Shop" collection, which
      // Rebecca can drag to reorder in the admin. The old JS core-first sort
      // fought that ordering, so it is gone.

      // Active-filter banner
      const banner = document.querySelector('[data-scc-active]');
      const pills = document.querySelector('[data-scc-active-pills]');
      if (banner && pills) {
        const labels = [];
        facets.querySelectorAll('[data-scc-check]:checked').forEach((c) => {
          const txt = c.parentElement.textContent.trim();
          if (txt) labels.push(txt);
        });
        if (lo > priceMin || hi < priceMax) labels.push('$' + lo + ' to $' + hi);
        pills.innerHTML = labels.map((l) => '<span class="scc-active__pill"></span>').join('');
        [...pills.children].forEach((el, i) => (el.textContent = labels[i]));
        banner.hidden = labels.length === 0;
      }

      const clear = facets.querySelector('[data-scc-clear]');
      if (clear) clear.hidden = active.length === 0;
      // RRP: the Start Here strip lives on the home page only. It used to sit
      // above this grid and be hidden while a filter was on, but showing and
      // hiding ~1100px above the viewport fought Horizon's scroll handling
      // and read as the page jumping to the top. Nothing above the grid
      // changes size on a filter change any more.

      // Keep Horizon's "N items" count honest.
      const counter = document.querySelector('[class*="product-count"], .collection__count');
      if (counter && active.length) counter.textContent = `${shown} item${shown === 1 ? '' : 's'}`;
    };

    facets.addEventListener('change', (e) => {
      // change fires on release, which is where the snap belongs
      if (e.target.matches('[data-scc-min], [data-scc-max]')) snapUp();
      if (e.target.matches('[data-scc-check], [data-scc-min], [data-scc-max]')) apply();
    });
    facets.addEventListener('input', (e) => {
      if (e.target.matches('[data-scc-min], [data-scc-max]')) apply();
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-scc-clear]')) return;
      facets.querySelectorAll('[data-scc-check]').forEach((c) => (c.checked = false));
      if (rMin) rMin.value = String(priceMin);
      if (rMax) rMax.value = String(priceMax);
      apply();

      // RRP: Horizon's infinite scroll appends the next page of cards after
      // apply() has run, so those cards arrived unfiltered (signature courses
      // showing under "Templates"). Re-apply whenever the grid gains children.
      // Watches the whole document, not the grid: Horizon can swap the grid
      // element itself when it renders the next page, which orphaned a
      // grid-only observer.
      if ('MutationObserver' in window) {
        let pending = false;
        new MutationObserver((records) => {
          const added = records.some((r) =>
            [...r.addedNodes].some((n) => n.nodeType === 1 && (n.matches?.(cardSelector) || n.querySelector?.(cardSelector)))
          );
          if (!added || pending) return;
          pending = true;
          requestAnimationFrame(() => { pending = false; apply(); });
        }).observe(document.body, { childList: true, subtree: true });
      }
    });

    // Header category links arrive as ?filter=topic-branding. Tick the matching
    // box so the sidebar shows the state rather than filtering invisibly.
    // Scrolling is handled by a native #shop anchor on the category links.
    // Programmatic scrolling proved unreliable here: Horizon scrolls
    // `.page-wrapper` rather than the window, and even assigning scrollTop on
    // it directly was reset synchronously. The browser resolves anchors
    // against whatever element actually scrolls, so it just works.
    const wanted = new URLSearchParams(location.search).get('filter');
    if (wanted) {
      const box = facets.querySelector('[data-scc-check][value="' + CSS.escape(wanted) + '"]');
      if (box) {
        box.checked = true;
        const openable = box.closest('details');
        if (openable) openable.open = true;

        // Arriving from a category link should land on the products, not at
        // the top of the page with the filtering already done out of sight.
        // rAF alone fired before the grid had laid out and Horizon's own
        // scripts then reset the scroll, so this waits for load and re-measures.
      }
    }

    // "Hide filters" toggle in the sticky bar.
    const rail = document.querySelector('.facets-block-wrapper, .facets__form-wrapper');
    const toggle = document.querySelector('[data-scc-toggle-filters]');
    if (toggle && rail) {
      toggle.addEventListener('click', () => {
        const hidden = rail.hasAttribute('data-scc-hidden');
        if (hidden) rail.removeAttribute('data-scc-hidden');
        else rail.setAttribute('data-scc-hidden', '');
        toggle.textContent = hidden ? 'Hide filters' : 'Show filters';
        document.querySelector('.collection-wrapper, .main-collection-grid')
          ?.classList.toggle('scc-filters-collapsed', !hidden);
      });
    }

    // Run once on load so core products lead before anyone touches a filter.
    apply();

    // Close a dropdown when clicking away, matching how Price behaves.
    document.addEventListener('click', (e) => {
      facets.querySelectorAll('details[open]').forEach((d) => {
        if (!d.contains(e.target)) d.open = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scc-how-it-works"] && !Shopify.designMode) return;
  try {
    
  /**
   * Reveals the three cards as they scroll into view.
   *
   * Deliberately vanilla and self-contained: Horizon is already fighting for
   * mobile performance and this does not justify a dependency. The observer is
   * skipped entirely when the visitor prefers reduced motion, in which case the
   * cards are simply painted in their final state by the CSS default.
   */
  (() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) return;

    const cards = document.querySelectorAll('[data-scc-reveal]');
    if (!cards.length) return;

    cards.forEach((c) => c.classList.add('scc-hiw--pending'));

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.remove('scc-hiw--pending');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    cards.forEach((c) => io.observe(c));
  })();

  } catch(e) { console.error(e); }
})();
})();
